'use client';

import { CircularProgressLoader } from '@northladder/design-system';
import { Text } from '@northladder/i18n';

import { translations } from '../../translations';

/**
 * -----------------------------------------------------------------------------
 * This is rendered while the app is retrieving the images list from the provided
 * sessionId in the url on first launch or refresh.
 */
export function RedirectLoading() {
  return (
    <div className="flex min-h-[calc(100vh-15rem)] flex-col justify-center">
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="shadow-xs bg-white px-4 py-8 sm:rounded-lg sm:px-10">
          <div className="mx-auto px-4 text-center sm:px-6 lg:px-8">
            <div className="mx-auto flex max-w-4xl flex-col items-center py-8">
              <CircularProgressLoader
                className="my-12 h-12 w-12"
                strokeWidth={6}
              />
              <h1 className="text-primary-700 text-xl font-normal tracking-tight sm:text-xl">
                <Text text={translations.redirectLoading.title} />
              </h1>
              <p className="text-primary-900 my-8 max-w-xl font-light">
                <Text text={translations.redirectLoading.subTitle} />
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
